export const LEAD_DROP_FORM_10_CONSTANTS = {
  DEFAULT_ROW: {
    title: "Apply Now",
    sub_text: "Please enter your details.",
    checkbox_description:
      "By clicking on submit I allow the university to send program communication on email/SMS/WhatsApp etc.",
    button_text: "Apply Now",
    button_color: "#BE2330",
    button_icon: "",
    button_text_color: "#FFFFFF",
    button_background_color: "#BE2330",
    title_color: "#BE2330",
    sub_text_color: "#666666",
    button_disabled_color: "#9CA3AF",
    checkbox_color: "#BE2330",
    success_icon: "",
    success_title: "",
    success_description: "",
    success_description_text_color: "#000000",
    success_description_color: "#000000",
    success_button_icon: "",
    success_button_text: "",
    success_button_text_color: "#FFFFFF",
    success_button_background_color: "#BE2330",
  },

  LEAD_DROP_FORM_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Title",
      value: "Apply Now",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Title",
      required: true,
      defaultValue: "Apply Now",
    },
    {
      fieldName: "sub_text",
      label: "Sub Text",
      value: "Please enter your details.",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter Sub Text",
      required: false,
      defaultValue: "Please enter your details.",
      rows: 3,
    },
    {
      fieldName: "checkbox_description",
      label: "Checkbox Description",
      value:
        "By clicking on submit I allow the university to send program communication on email/SMS/WhatsApp etc.",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter Checkbox Description",
      required: false,
      defaultValue:
        "By clicking on submit I allow the university to send program communication on email/SMS/WhatsApp etc.",
      rows: 2,
    },
    {
      fieldName: "button_text",
      label: "Button Text",
      value: "Apply Now",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Button Text",
      required: false,
      defaultValue: "Apply Now",
    },
    {
      fieldName: "button_color",
      label: "Button Color",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Button Color (e.g., #BE2330)",
      required: false,
      defaultValue: "#BE2330",
    },
    {
      fieldName: "button_icon",
      label: "Button Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Button Icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "button_icon_alt",
      label: "Button Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for button icon",
      required: false,
      defaultValue: "Apply Now",
    },
    {
      fieldName: "button_text_color",
      label: "Button Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Button Text Color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "button_background_color",
      label: "Button Background Color",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Button Background Color (e.g., #BE2330)",
      required: false,
      defaultValue: "#BE2330",
    },
    {
      fieldName: "title_color",
      label: "Title Color",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Title Color (e.g., #BE2330)",
      required: false,
      defaultValue: "#BE2330",
    },
    {
      fieldName: "sub_text_color",
      label: "Sub Text Color",
      value: "#666666",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Sub Text Color (e.g., #666666)",
      required: false,
      defaultValue: "#666666",
    },
    {
      fieldName: "button_disabled_color",
      label: "Apply Now Disabled Color",
      value: "#9CA3AF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Disabled button background (e.g., #9CA3AF)",
      required: false,
      defaultValue: "#9CA3AF",
    },
    {
      fieldName: "checkbox_color",
      label: "Checkbox Color",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Checkbox checked color (e.g., #BE2330)",
      required: false,
      defaultValue: "#BE2330",
    },
    {
      fieldName: "success_icon",
      label: "Success Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Success Icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "success_icon_alt",
      label: "Success Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for success icon",
      required: false,
      defaultValue: "Success",
    },
    {
      fieldName: "success_title",
      label: "Success Title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Success Title",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "success_description",
      label: "Success Description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter Success Description",
      required: false,
      defaultValue: "",
      rows: 3,
    },
    {
      fieldName: "success_description_text_color",
      label: "Success Description Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Success Description Text Color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "success_description_color",
      label: "Success Description Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Success Description Color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "success_button_icon",
      label: "Success Button Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Success Button Icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "success_button_icon_alt",
      label: "Success Button Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for success button icon",
      required: false,
      defaultValue: "Continue",
    },
    {
      fieldName: "success_button_text",
      label: "Success Button Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Success Button Text",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "success_button_text_color",
      label: "Success Button Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Success Button Text Color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "success_button_background_color",
      label: "Success Button Background Color",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Success Button Background Color (e.g., #BE2330)",
      required: false,
      defaultValue: "#BE2330",
    },
  ],

  METADATA_FIELDS: [],
};
